import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { lastValueFrom, timeout } from "rxjs";

import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class DertApiService {
  constructor(private http: HttpClient) {}

  public static readonly aliveDefaults = {
    action: "trip",
    user: 123,
    selectedBusinessUnit: 999,
    roles: ["seller", "branch_manager", "network_manager", "accountant", "administrator", "fr_seller", "fr_branch_manager"].join(","),
    email: "tomas.chovanec@ngretail.cz",
    name: "Tomáš Chovanec",
    login: "tomas.chovanec",
  } as const;

  // For testing purposes
  public async alive(
    bnr: string | number,
    voucher: string | null = null,
    action: string = DertApiService.aliveDefaults.action,
    user: string | number = DertApiService.aliveDefaults.user,
    selectedBusinessUnit: string | number = DertApiService.aliveDefaults.selectedBusinessUnit,
    roles: string = localStorage.getItem('roles') || DertApiService.aliveDefaults.roles,
    email: string = DertApiService.aliveDefaults.email,
    name: string = DertApiService.aliveDefaults.name,
    login: string = DertApiService.aliveDefaults.login
  ): Promise<any> {
    const url = `api/dert/alive`;

    let toEncode =
      `action=${action || DertApiService.aliveDefaults.action}` +
      `&user=${user || DertApiService.aliveDefaults.user}` +
      `&bnr=${bnr}` +
      `&selectedBusinessUnit=${selectedBusinessUnit || DertApiService.aliveDefaults.selectedBusinessUnit}` +
      `&roles=${roles || localStorage.getItem('roles') ||  DertApiService.aliveDefaults.roles}` +
      `&email=${email || DertApiService.aliveDefaults.email}` +
      `&name=${name || DertApiService.aliveDefaults.name}` +
      `&login=${login || DertApiService.aliveDefaults.login}`;
    if (voucher) {
      toEncode = toEncode.concat(`&voucher=${voucher}`);
    }
    toEncode = toEncode.concat(`&timestamp=${this.getTimestamp()}`);

    console.log("toEncode:", toEncode);

    const toEncodeBase64 = btoa(encodeURIComponent(toEncode));
    console.log("toEncodeBase64:", toEncodeBase64);

    const aliveRes = (await lastValueFrom(
      this.http.get(
        `${environment.apiAddress}/${url}?toEncodeBase64=${toEncodeBase64}`
      )
    )) as any;

    console.log("toEncodedQueryParam:", aliveRes.sampleForRedirect);

    let redirectUrl = `${window.location.origin}/redirect?countryCode=cz&encoded=${aliveRes.sampleForRedirect}`;

    console.log("redirectUrl:", redirectUrl);

    window.location.href = redirectUrl;
  }

  private getTimestamp(): string {
    const now = new Date();
    const pad = (value: number, digits: number) => value.toString().padStart(digits, "0");
    return `${now.getFullYear()}${pad(now.getMonth() + 1, 2)}${pad(now.getDate(), 2)}${pad(now.getHours(), 2)}${pad(now.getMinutes(), 2)}${pad(now.getSeconds(), 2)}`;
  }

  public async loadConfig(configName: string): Promise<any> {
    try {
      const url = `${environment.apiAddress}/api/dert/GetConfig`;
      const body = {
        ConfigName: configName,
      };
      const result = this.http.post(url, body).pipe(timeout(5000));
      return lastValueFrom(result);
    } catch (error) {
      console.error("Error loading config:", error);
      return null;
    }
  }

  public async printTransaction(transactionUid: string) {
     try {
      const url = `${environment.apiAddress}/api/dert/PrintTransaction?transactionUID=${transactionUid}`;
      var printResult = await lastValueFrom(this.http.get(url));
      return printResult;
    } catch (error) {
      console.error("Error loading config:", error);
      return null;
    }
  }
}
